import { IssuesDefaultSort } from 'pages/Desk/issues/shared';
import { DeskState, DeskStateValues } from 'pages/Desk/issues/state/types';
import {
    createBatchFilterUpdate,
    createFilterSetters,
    DEFAULT_ISSUE_FILTERS,
} from 'shared/issue_filters_context/StoreUtils';
import { ZustandContextInitializer } from 'shared/zustand_context/zustand_context';

const DefaultFilterStateValues: Omit<
    DeskStateValues,
    'queuedIssueIds' | 'isInitialized'
> = {
    ...DEFAULT_ISSUE_FILTERS,
    sort: IssuesDefaultSort,
};

export const DefaultDeskStateValues: DeskStateValues = {
    isInitialized: false,
    ...DefaultFilterStateValues,
    queuedIssueIds: [],
};

export const getDeskStateInitializer =
    (overrides: Partial<DeskStateValues> = {}): ZustandContextInitializer<DeskState> =>
    (set, _get) => {
        const deskState: DeskState = {
            ...DefaultDeskStateValues,
            ...overrides,
            ...createFilterSetters(set),
            setSort: (sort) => set({ sort }),
            setQueuedIssueIds: (queuedIssueIds) => set({ queuedIssueIds }),
            onFiltersChange: createBatchFilterUpdate(set),
        };

        return deskState;
    };
